import { Col, Container, OverlayTrigger, Row, Popover } from "react-bootstrap";
import { useState } from "react";
import Swal from "sweetalert2";
import { connect } from "react-redux";
import { logout, signOn } from "../../Store/Utils/thunkCreators";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import "./Navbar.css";

const Navbar = ({
  closeMobileNavbar,
  setCloseMobileNavbar,
  expandServicesMobileNav,
  setExpandServicesMobileNav,
  user,
  signOn,
  logout,
}) => {
  const [show, setShow] = useState(false);
  const [expandProfileMobile, setExpandProfileMobile] = useState(false);
  const navigate = useNavigate();
  const token = Cookies.get("token");

  const telegramData = [
    {
      logo: "views",
      alt: "tg-views",
      title: "Накрутка Просмотров",
      link: "service/telegram/views",
    },
    {
      logo: "bots",
      alt: "tg-bots",
      title: "Накрутка Ботов",
      link: "service/telegram/bots",
    },
    // {
    //   logo: "groupMsg",
    //   alt: "tg-groupMsg",
    //   title: "Рассылка по групповым чатам",
    //   link: "service/telegram/group",
    // },
    {
      logo: "msg",
      alt: "tg-msg",
      title: "Рассылка в личные сообщения",
      link: "service/telegram/message",
    },
    {
      logo: "inviting",
      alt: "tg-invite",
      title: "Инвайтинг",
      link: "service/telegram/inviting",
    },
  ];

  const tiktokData = [
    {
      logo: "like",
      alt: "tt-likes",
      title: "Лайки",
      link: "service/tiktok/likes",
    },
    {
      logo: "groupMsg",
      alt: "tg-subs",
      title: "Подписчики",
      link: "service/tiktok/subs",
    },
    {
      logo: "share",
      alt: "tg-share",
      title: "Репосты",
      link: "service/tiktok/share",
    },
    {
      logo: "views",
      alt: "tt-views",
      title: "Просмотры",
      link: "service/tiktok/views",
    },
  ];

  const contactModalHTML = `
    <div class="container">
      <div class="row">
        <div class="col-md-4 col-12">
          <div class="contact-modal-svg-container">
            <div class="contact-modal-faq"> FAQ</div>
          </div>
          <div class="contact-modal-title">Часто задаваемые вопросы</div>
          <div class="contact-modal-description">
            Огромная база вопросов и ответов уже ожидают вас, почти наверняка
            вопрос, который вы хотите задать был разобран.
          </div>
          <a target="_blank" href="https://www.pavelandco.com/faq">
            
            <button class="button-type-1">Выбрать</button>
          </a>
        </div>
        <div class="col-md-4 col-12">
          <div class="contact-modal-svg-container">
            <svg
              width="119"
              height="120"
              viewBox="0 0 119 120"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="118.887"
                y="60"
                width="84.0658"
                height="84.0658"
                rx="20"
                transform="rotate(135 118.887 60)"
                fill="url(#paint0_linear_332_996)"
              />
              <path
                d="M61.6272 72.668L53.1705 63.9888C51.8099 64.7246 51.1676 65.7691 50.7225 67.5495C50.5 69.1073 50.9062 70.1883 52.0578 71.7778C53.3931 72.8906 54.5601 73.1606 56.5087 73.5582H59.4018L60.737 73.1131L61.6272 72.668Z"
                fill="#343995"
              />
              <path
                d="M24.6949 80.4525C24.6949 66.5094 24.6918 52.5664 24.6855 38.6233C30.8676 38.6171 37.0434 38.6171 43.213 38.6233C45.9678 38.6233 48.4239 39.2396 50.5717 40.472C52.7662 41.6671 54.4658 43.3291 55.7078 45.4392C56.9779 47.5494 57.6222 49.9863 57.6222 52.7313C57.6222 55.551 56.9872 58.0907 55.7078 60.3222C54.4752 62.4977 52.7569 64.2343 50.5624 65.5135C48.4239 66.7926 45.9678 67.4182 43.213 67.4275C40.9842 67.4275 38.7523 67.4275 36.5173 67.4275C36.5236 71.7723 36.5236 76.1139 36.5173 80.4525C32.5765 80.4587 28.6357 80.4587 24.6949 80.4525ZM36.3399 57.213C37.9586 57.213 39.5741 57.213 41.1866 57.213C42.0177 57.213 42.7554 57.0449 43.3998 56.7368C44.0348 56.3727 44.5297 55.8778 44.8939 55.2429C45.2955 54.5987 45.4916 53.8144 45.4822 52.8994C45.4822 51.9844 45.2955 51.2374 44.8939 50.6305C44.5391 50.033 44.0348 49.5941 43.3998 49.314C42.7648 49.0059 42.0177 48.8472 41.1772 48.8472C39.571 48.8472 37.9586 48.8472 36.3399 48.8472C36.3461 51.6358 36.3461 54.4244 36.3399 57.213Z"
                fill="#343995"
              />
              <path
                d="M79.4479 80.9022C76.2741 80.9022 73.3542 80.3761 70.6791 79.3328C68.0131 78.2805 65.7007 76.8381 63.7148 74.9693C61.7924 73.0733 60.269 70.8507 59.1899 68.3015C58.1561 65.707 57.6211 62.8584 57.6211 59.765C57.6211 56.7078 58.1742 53.8955 59.2443 51.3373C60.3778 48.7428 61.9193 46.5111 63.8962 44.6151C65.864 42.71 68.2035 41.2404 70.9239 40.1971C73.6262 39.1448 76.5915 38.6277 79.8015 38.6187C81.733 38.6277 83.6011 38.8817 85.4328 39.3716C87.2827 39.8433 89.0147 40.5509 90.6469 41.4763C92.2701 42.4016 93.7301 43.5628 95.0087 44.9598C92.7054 47.633 90.3991 50.3031 88.0897 52.9702C87.4368 52.2354 86.7023 51.5732 85.8953 51.0016C85.0792 50.421 84.1542 49.9674 83.1114 49.659C82.1048 49.3143 80.9804 49.1419 79.7381 49.1419C78.3053 49.1419 76.9542 49.3869 75.6665 49.8949C74.4423 50.3575 73.3451 51.047 72.4202 51.9723C71.5043 52.9158 70.7607 54.0316 70.2166 55.347C69.7179 56.6624 69.473 58.1774 69.464 59.8829C69.473 61.5067 69.7088 62.9764 70.2257 64.2918C70.7516 65.5709 71.5133 66.6777 72.4746 67.5939C73.4902 68.492 74.669 69.1815 76.0292 69.6895C77.4166 70.1975 78.9673 70.4334 80.6721 70.4334C81.8691 70.4425 82.9935 70.2701 84.0273 69.9254C85.1064 69.5716 86.0948 69.0998 86.9925 68.5283C87.8721 67.9386 88.6792 67.3127 89.3774 66.6142C91.1971 69.499 93.0137 72.3838 94.8273 75.2686C93.857 76.3482 92.5422 77.3189 90.8827 78.1716C89.2595 79.0244 87.4368 79.6866 85.4328 80.2037C83.4469 80.6663 81.461 80.9022 79.4479 80.9022Z"
                fill="#343995"
              />
              <path
                d="M71.1456 81.6658C69.9844 80.4802 68.8201 79.2976 67.6528 78.118C66.0924 76.7086 64.529 75.2931 62.9625 73.8715C60.3678 71.1676 57.7732 68.4606 55.1785 65.7506C53.4003 63.9268 51.9488 62.2935 50.8148 60.8689C49.7352 59.4353 48.9096 58.1378 48.329 56.9763C47.7846 55.8149 47.4036 54.7533 47.1586 53.7915C46.9681 52.8206 46.8683 51.9314 46.8774 51.1147C46.8683 48.9824 47.4399 47.0769 48.5648 45.4255C49.717 43.7197 51.3137 42.3858 53.3278 41.4059C55.3237 40.4532 57.6734 39.9541 60.3497 39.9541C62.3637 39.9541 64.2598 40.2898 66.038 40.9431C67.8615 41.5692 69.3947 42.4584 70.683 43.6199C71.9984 44.7904 72.9329 46.1424 73.4591 47.694C70.5862 49.3756 67.7073 51.0542 64.8223 52.7298C64.2326 51.2327 63.6157 50.2346 62.9625 49.7809C62.3456 49.3181 61.6107 49.0822 60.7489 49.0822C60.0957 49.0822 59.515 49.1911 59.0161 49.4361C58.5534 49.6176 58.1814 49.9533 57.9002 50.407C57.6371 50.8425 57.501 51.3597 57.501 51.9858C57.4919 52.7117 57.8367 53.6281 58.4899 54.7079C59.1884 55.7605 60.0412 56.8856 61.0392 58.0833C62.0915 59.281 63.1349 60.4243 64.1782 61.5132C65.2668 62.5929 66.1831 63.5275 66.9724 64.2897C67.8615 65.2273 68.7506 66.1589 69.6396 67.0844C71.315 68.5786 72.9994 70.0697 74.6929 71.5577C77.9045 74.9211 81.116 78.2904 84.3276 81.6658C79.9366 81.6658 75.5426 81.6658 71.1456 81.6658ZM56.8569 82.2375C53.6907 82.2465 50.842 81.6658 48.329 80.5044C45.8522 79.343 43.8745 77.7551 42.3957 75.7407C40.9714 73.681 40.2637 71.3853 40.2637 68.8266C40.2547 66.1135 41.0621 63.6364 42.686 61.3861C44.3281 59.1086 46.7413 57.3756 49.9529 56.2141C52.1786 58.2769 54.4013 60.3336 56.621 62.3842C54.6614 62.847 53.1282 63.582 52.0486 64.5892C51.0053 65.56 50.4791 66.7759 50.47 68.2368C50.4791 69.4073 50.7694 70.4054 51.3409 71.2674C51.9306 72.084 52.7471 72.7192 53.7905 73.1819C54.87 73.5993 56.1855 73.8262 57.7278 73.8262C59.1703 73.8262 60.513 73.5086 61.8012 72.8916C63.1167 72.2746 64.278 71.4216 65.285 70.3419C66.292 69.2167 67.0903 67.8738 67.7254 66.3313C68.3423 64.7434 68.7324 63.0013 68.8867 61.1049C72.2736 61.1049 75.6606 61.1049 79.0476 61.1049C78.7391 63.6183 78.1313 65.9593 77.2422 68.1188C76.344 70.2965 75.2281 72.2564 73.8764 73.9895C72.5246 75.7316 70.9642 77.2288 69.2314 78.4719C67.4895 79.7059 65.5753 80.6496 63.4887 81.312C61.4202 81.929 59.2247 82.2465 56.8569 82.2375Z"
                fill="white"
              />
              <path
                d="M58.2893 54.4192L60.5148 49.0781C60.1795 49.1314 59.7744 49.1465 59.402 49.3007C59.0277 49.4283 58.8302 49.4609 58.5119 49.7458C58.0002 50.2035 57.8571 50.3167 57.6217 51.081C57.2223 52.3779 57.5251 53.4216 58.2893 54.4192Z"
                fill="#343995"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_332_996"
                  x1="97.7609"
                  y1="100.077"
                  x2="233.795"
                  y2="101.22"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.016443" stop-color="#FEAC5E" />
                  <stop offset="0.463542" stop-color="#C779D0" />
                  <stop offset="0.926375" stop-color="#4BC0C8" />
                  <stop offset="0.969693" stop-color="#4BC0C8" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div class="contact-modal-title">Чат на сайте</div>
          <div class="contact-modal-description">
            Быстрые и оперативные операторы на сайте всегда готовы помочь вам с
            оформлением заказа и ответить на все ваши вопросы.
          </div>
          <a href="javascript:jivo_api.open();">
            <button class="button-type-1">Выбрать</button>
          </a>
        </div>
        <div class="col-md-4 col-12">
          <div class="contact-modal-svg-container">
            <svg
              width="110"
              height="110"
              viewBox="0 0 19 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="9.5" cy="9.5" r="9.5" fill="#2F89CE" />
              <path
                d="M4.44197 9.67788L6.62607 10.4923L7.47749 13.2317C7.51451 13.4167 7.73662 13.4538 7.8847 13.3427L9.1063 12.3432C9.21735 12.2322 9.40245 12.2322 9.55053 12.3432L11.7346 13.935C11.8827 14.0461 12.1048 13.972 12.1418 13.7869L13.7706 6.01306C13.8076 5.82796 13.6226 5.64287 13.4375 5.71691L4.44197 9.19665C4.21986 9.27068 4.21986 9.60385 4.44197 9.67788ZM7.36644 10.0851L11.6606 7.45678C11.7346 7.41976 11.8086 7.53081 11.7346 7.56783L8.21786 10.8625C8.1068 10.9735 7.99575 11.1216 7.99575 11.3067L7.8847 12.1951C7.8847 12.3062 7.6996 12.3432 7.66258 12.1951L7.21836 10.5663C7.1073 10.3812 7.18135 10.1591 7.36644 10.0851Z"
                fill="white"
              />
            </svg>
          </div>
          <div class="contact-modal-title">Telegram</div>
          <div class="contact-modal-description">
            Располагаем оператором в Telegram, который так же сможет помочь
            разобраться с возникшими вопросами.
          </div>
          <a target="_blank" href="https://www.t.me/promotelega">
            
            <button class="button-type-1">Выбрать</button>
          </a>
        </div>
      </div>
    </div>`;

  const login = {
    title: "Вход",
    html: `
      <div class="container">
        <div class="row">
          <div class="col">
          <form>
            <div class="login-modal-input-title">Введите Email</div>
            <input class="input-type-1" id="email" name="email" required />
            <div class="login-modal-input-title">Введите пароль</div>
            <input
              class="input-type-1"
              id="password"
              name="password"
              type="password"
              required
            />
            </forzm>
          </div>
        </div>
      </div>`,
  };

  const register = {
    title: "Регистрация аккаунта",
    html: `
    <div class="container">
      <div class="row">
        <div class="col">
        <form>
          <div class="login-modal-input-title">Введите Email</div>
          <input class="input-type-1" id="email" name="email" required />
          <div class="login-modal-input-title">Введите пароль</div>
          <input
            class="input-type-1"
            id="password"
            name="password"
            type="password"
            required
          />
          </form>
        </div>
      </div>
    </div>`,
  };

  const reset = {
    title: "Восстановление пароля",
    html: `
      <div class="container">
        <div class="row">
          <div class="col">
          <form>
          <div class="reset-pass-hint-modal">Укажите Email, привязанный к аккаунту.
          Мы пришлем ссылку для сброса пароля в течение 5 минут.</div>
            <div class="login-modal-input-title">Введите Email</div>
            <input class="input-type-1" id="email" name="email" required />
            </form>
          </div>
        </div>
      </div>`,
  };

  const handleContact = () => {
    Swal.fire({
      title: "Помощь",
      html: contactModalHTML,
      showCloseButton: true,
      showConfirmButton: false,
      customClass: {
        popup: "contact-modal-popup",
        title: "details-modal-top-title",
        closeButton: "pop-up-type-1-close",
      },
    });
  };

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    showCloseButton: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  const handleResetModal = async (content) => {
    const result = await Swal.fire({
      title: content.title,
      html: content.html,
      showCloseButton: true,
      focusConfirm: false,
      showConfirmButton: true,
      confirmButtonText: "ВОСТАНОВИТЬ",
      showDenyButton: true,
      denyButtonText: "Вспомнили пароль? <a>Войти</a>",
      buttonsStyling: false,
      customClass: {
        popup: "pop-up-type-1 login-pop-up",
        title: "pop-up-type-1-title",
        closeButton: "pop-up-type-1-close",
        confirmButton: "button-type-1",
        denyButton: "login-redirect-button",
      },
      preConfirm: () => {
        const submitData = {
          email: document.getElementById("email").value,
          lang: "RU",
        };
        return fetch(`https://api.pavelandco.com/api/user/forgotpass`, {
          method: "PUT",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(submitData),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(response.status);
            }
            Toast.fire({
              icon: "success",
              title: `Письмо с инструкциями отправленно на почту`,
            });
            return response.json();
          })
          .catch((error) => {
            if (error.message === "404") {
              Swal.showValidationMessage(`Пользователь не найден`);
            } else Swal.showValidationMessage(`Ошибка: ${error}`);
          });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
    if (result.isDenied) {
      await handleLoginModal(login);
    }
  };

  const handleRegisterModal = async (content) => {
    const result = await Swal.fire({
      title: content.title,
      html: content.html,
      showCloseButton: true,
      focusConfirm: false,
      showConfirmButton: true,
      confirmButtonText: "СОЗДАТЬ АККАУНТ",
      showDenyButton: true,
      denyButtonText: "Есть аккаунт? <a>Войти</a>",
      buttonsStyling: false,
      customClass: {
        popup: "pop-up-type-1 login-pop-up",
        title: "pop-up-type-1-title",
        closeButton: "pop-up-type-1-close",
        confirmButton: "button-type-1",
        denyButton: "login-redirect-button",
      },
      preConfirm: async () => {
        try {
          await handleRegister(
            document.getElementById("email").value,
            document.getElementById("password").value
          );
        } catch (error) {
          Swal.showValidationMessage(`Ошибка: ${error}`);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
    if (result.isDenied) {
      await handleLoginModal(login);
    }
  };

  const handleLoginModal = async (content) => {
    const result = await Swal.fire({
      title: content.title,
      html: content.html,
      showCloseButton: true,
      focusConfirm: false,
      showConfirmButton: true,
      confirmButtonText: "ВОЙТИ",
      showDenyButton: true,
      showCancelButton: true,
      denyButtonText: "Забыли пароль? <a>Восстановить</a>",
      cancelButtonText: "Нет аккаунта? <a>Регистрация</a>",
      buttonsStyling: false,
      customClass: {
        popup: "pop-up-type-1 login-pop-up",
        title: "pop-up-type-1-title",
        closeButton: "pop-up-type-1-close",
        confirmButton: "button-type-1",
        denyButton: "login-redirect-button",
        cancelButton: "login-redirect-button",
      },
      preConfirm: async () => {
        try {
          await handleLogin(
            document.getElementById("email").value,
            document.getElementById("password").value
          );
        } catch (error) {
          Swal.showValidationMessage(`Ошибка: ${error}`);
          return false;
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
    if (result.isDenied) {
      await handleResetModal(reset);
    } else if (result.isDismissed && result.dismiss === "cancel") {
      await handleRegisterModal(register);
    }
  };

  const handleLogin = async (email, password) => {
    await signOn({ email, password, type: "login" });
  };

  const handleRegister = async (email, password) => {
    await signOn({
      email,
      password,
      leadSource: localStorage.getItem("leadSource"),
      type: "register",
    });
  };

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <>
      <nav>
        <Container fluid>
          <Row className="navbar-row">
            <Col xs={2} className="nav-logo-col">
              <Link to="/" className="hide-on-mobile hide-on-medium">
                <img
                  src={`${process.env.PUBLIC_URL}/images/navbarLogo.svg`}
                  alt="navbarLogo"
                />
              </Link>
              <button
                className={`orders-top-up-button hide-on-desktop ${
                  closeMobileNavbar ? "close-mobile-navbar" : undefined
                } ${
                  expandServicesMobileNav
                    ? "mobile-services-expanded-clicked"
                    : undefined
                }`}
              >
                <div className="btn-profile-contaniner">
                  <span
                    className="nav__icon"
                    onClick={() => {
                      setCloseMobileNavbar((prev) => !prev);
                      setExpandProfileMobile(false);
                      setExpandServicesMobileNav(false);
                    }}
                  />
                </div>
                <div className="navbar-links">
                  <p>
                    <Link
                      to="/"
                      onClick={() => {
                        setCloseMobileNavbar(false);
                        setExpandServicesMobileNav(false);
                      }}
                    >
                      Главная
                    </Link>
                  </p>
                  <p>
                    <div
                      className={`mobile-navbar-all-services-button ${
                        expandServicesMobileNav
                          ? "mobile-services-expanded"
                          : undefined
                      }`}
                      onClick={() =>
                        setExpandServicesMobileNav((prev) => !prev)
                      }
                    >
                      <a className="mobile-navbar-all-services-button-title">
                        Каталог услуг
                        <img
                          src={`${process.env.PUBLIC_URL}/images/arrowDown.svg`}
                          alt="arrowDown"
                          className="arrow-down"
                        />
                      </a>

                      <div className="all-mobile-services-list">
                        <div className="popover-service-network">
                          <img
                            src={`${process.env.PUBLIC_URL}/images/telegram.svg`}
                            alt="tg-logo"
                          />
                          <span className="service-network">Telegram</span>
                        </div>
                        <ul className="service-types">
                          {telegramData.map((service) => {
                            return (
                              <li key={service.alt}>
                                <Link
                                  to={service.link}
                                  onClick={() => {
                                    setShow(false);
                                    setCloseMobileNavbar(false);
                                  }}
                                >
                                  <img
                                    src={`${process.env.PUBLIC_URL}/images/${service.logo}.svg`}
                                    alt={service.alt}
                                  />
                                  <div>{service.title}</div>
                                </Link>
                              </li>
                            );
                          })}
                        </ul>
                        <div className="popover-service-network">
                          <img
                            src={`${process.env.PUBLIC_URL}/images/tiktok.svg`}
                            alt="tt-logo"
                          />
                          <span className="service-network">Tik Tok</span>
                        </div>
                        <ul className="service-types">
                          {tiktokData.map((service) => {
                            return (
                              <li key={service.alt}>
                                <Link
                                  to={service.link}
                                  onClick={() => {
                                    setShow(false);
                                    setCloseMobileNavbar(false);
                                  }}
                                >
                                  <img
                                    src={`${process.env.PUBLIC_URL}/images/${service.logo}.svg`}
                                    alt={service.alt}
                                  />
                                  <div>{service.title}</div>
                                </Link>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  </p>
                  <p>
                    <a
                      className={`mobile-navbar-all-services-button`}
                      onClick={handleContact}
                    >
                      Помощь
                    </a>
                  </p>
                </div>
              </button>
            </Col>
            <Col xs={8} className="hide-on-desktop mobile-navbar-logo-col">
              <Link to="/" onClick={() => setCloseMobileNavbar(false)}>
                <img
                  src={`${process.env.PUBLIC_URL}/images/navbarLogo.svg`}
                  alt="navbarLogo"
                  className="mobile-navbar-logo"
                />
              </Link>
            </Col>
            <Col md={8} className="nav-links-col hide-on-mobile hide-on-medium">
              <Link to="/" className="navbar-link">
                Главная
              </Link>
              <OverlayTrigger
                trigger={["click", "hover"]}
                key="bottom"
                placement="bottom"
                show={show}
                overlay={
                  <Popover id={`popover-positioned-${"bottom"}`}>
                    <Popover.Body>
                      <Container fluid>
                        <Row>
                          <Col md={8}>
                            <div className="popover-service-network">
                              <img
                                src={`${process.env.PUBLIC_URL}/images/telegram.svg`}
                                alt="tg-logo"
                              />
                              <span className="service-network">Telegram</span>
                            </div>
                            <ul className="service-types">
                              {telegramData.map((service) => {
                                return (
                                  <Link
                                    key={service.alt}
                                    to={service.link}
                                    onClick={() => setShow(false)}
                                  >
                                    <li>
                                      <img
                                        src={`${process.env.PUBLIC_URL}/images/${service.logo}.svg`}
                                        alt={service.alt}
                                      />
                                      <div>{service.title}</div>
                                    </li>
                                  </Link>
                                );
                              })}
                            </ul>
                          </Col>

                          <Col md={4}>
                            <div className="popover-service-network">
                              <img
                                src={`${process.env.PUBLIC_URL}/images/tiktok.svg`}
                                alt="tt-logo"
                              />
                              <span className="service-network">Tik Tok</span>
                            </div>
                            <ul className="service-types">
                              {tiktokData.map((service) => {
                                return (
                                  <Link
                                    key={service.alt}
                                    to={service.link}
                                    onClick={() => setShow(false)}
                                  >
                                    <li>
                                      <img
                                        src={`${process.env.PUBLIC_URL}/images/${service.logo}.svg`}
                                        alt={service.alt}
                                      />
                                      <div>{service.title}</div>
                                    </li>
                                  </Link>
                                );
                              })}
                            </ul>
                          </Col>
                        </Row>
                      </Container>
                    </Popover.Body>
                  </Popover>
                }
              >
                <span
                  className="navbar-link"
                  onClick={() => setShow((prev) => !prev)}
                >
                  Каталог услуг
                  <img
                    src={`${process.env.PUBLIC_URL}/images/arrowDown.svg`}
                    alt="arrowDown"
                    className="arrow-down"
                  />
                </span>
              </OverlayTrigger>
              <button className="navbar-link" onClick={handleContact}>
                Помощь
              </button>
            </Col>
            <Col xs={2} className="nav-login-button-col">
              {!token ? (
                <>
                  <button
                    className="button-type-1 hide-on-mobile hide-on-medium"
                    onClick={() => handleRegisterModal(register)}
                  >
                    РЕГИСТРАЦИЯ
                  </button>
                  <button
                    className="hide-on-desktop mobile-navbar-top-button"
                    onClick={() => handleRegisterModal(register)}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/images/login.svg`}
                      alt="login"
                      className="login-svg-image"
                    />
                  </button>
                </>
              ) : (
                <>
                  <button className="orders-top-up-button hide-on-mobile hide-on-medium">
                    <div className="btn-profile-contaniner ">
                      <img
                        src={`${process.env.PUBLIC_URL}/images/profile.svg`}
                        alt="profile"
                      />
                      {user && user.nickname}
                      <img
                        src={`${process.env.PUBLIC_URL}/images/arrowDown.svg`}
                        alt="arrowDown"
                        className="arrow-down"
                      />
                    </div>
                    <div className="navbar-links">
                      <p>
                        <Link
                          to="service/balance"
                          className="balance-navbar-link"
                        >
                          <div>Пополнить баланс</div>
                          <div>
                            {user &&
                              user.balanceRu &&
                              user.balanceRu.toFixed(2)}
                            ₽
                          </div>
                        </Link>
                      </p>
                      <p>
                        <Link to="service/orders">История заказов</Link>
                      </p>
                      <p>
                        <Link to="service/telegram">Каталог услуг</Link>
                      </p>
                      <p>
                        <Link to="service/settings">Настройки</Link>
                      </p>
                      <p>
                        <button onClick={handleLogout}>Выйти</button>
                      </p>
                    </div>
                  </button>
                  <button
                    className={`orders-top-up-button hide-on-desktop logged-in-profile-button ${
                      expandProfileMobile
                        ? "profile-mobile-expanded"
                        : undefined
                    }`}
                    onClick={() => {
                      setExpandProfileMobile((prev) => !prev);
                      setCloseMobileNavbar(false);
                      setExpandServicesMobileNav(false);
                    }}
                  >
                    <div className="btn-profile-contaniner logged-in-profile-button-container">
                      <img
                        src={`${process.env.PUBLIC_URL}/images/profile.svg`}
                        alt="profile"
                        className="mobile-navbar-profile-img"
                      />
                      {expandProfileMobile && (
                        <>
                          {user && user.nickname}
                          <img
                            src={`${process.env.PUBLIC_URL}/images/cross.svg`}
                            alt="cross"
                            className="arrow-down"
                          />
                        </>
                      )}
                    </div>
                    <div className="navbar-links">
                      <p>
                        <Link
                          to="service/balance"
                          className="balance-navbar-link"
                        >
                          <div>Пополнить баланс</div>
                          <div>
                            {user &&
                              user.balanceRu &&
                              user.balanceRu.toFixed(2)}
                            ₽
                          </div>
                        </Link>
                      </p>
                      <p>
                        <Link to="service/orders">История заказов</Link>
                      </p>
                      <p>
                        <Link to="service/settings">Настройки</Link>
                      </p>
                      <p>
                        <button onClick={handleLogout}>Выйти</button>
                      </p>
                    </div>
                  </button>
                </>
              )}
            </Col>
          </Row>
        </Container>
      </nav>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signOn: (credentials) => {
      dispatch(signOn(credentials));
    },
    logout: () => {
      dispatch(logout());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
